(function () {
  'use strict';

  var STORAGE_KEY = 'tx-mattress-compare-v1';
  var MAX_COMPARE = 3;
  var observer;
  var observerTimer;

  function normalizeSize(value) {
    var size = String(value || '').trim().toLowerCase();
    size = size.replace(/\s*\(.*/, '');
    size = size.replace(/\s*:\s*.*/, '');
    size = size.replace(/\s+-\s+\d.*$/, '');
    size = size.replace(/\s+/g, ' ').trim();
    if (/^short queen\b/.test(size)) return 'short queen';
    if (/^rv king\b/.test(size)) return 'rv king';
    if (/^(ca|cal|cal\.) king$/.test(size)) return 'california king';
    if (/^split (ca|cal|cal\.) king$/.test(size)) return 'split california king';
    return size;
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    return '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function sizePriceForCard(card, selected) {
    var records = String(card.getAttribute('data-tx-size-prices') || '').split('||');
    var match = null;
    for (var index = 0; index < records.length; index += 1) {
      var parts = records[index].split('~');
      if (normalizeSize(parts[0]) === selected) {
        var price = Number(parts[1] || 0);
        if (price > 0 && (!match || price < match.price)) {
          match = { price: price, comparePrice: Number(parts[2] || 0) };
        }
      }
    }
    return match;
  }

  function updateCardPrice(card, selected) {
    var priceBox = card.querySelector('.tx-mattress-starting-price');
    var payment = card.querySelector('.tx-mattress-card__payment strong');
    var savings = card.querySelector('.tx-mattress-card__savings');
    if (!priceBox) return;
    if (!priceBox.hasAttribute('data-tx-original-html')) priceBox.setAttribute('data-tx-original-html', priceBox.innerHTML);
    if (payment && !payment.hasAttribute('data-tx-original-html')) payment.setAttribute('data-tx-original-html', payment.innerHTML);
    if (savings && !savings.hasAttribute('data-tx-original-html')) savings.setAttribute('data-tx-original-html', savings.innerHTML);

    if (!selected) {
      priceBox.innerHTML = priceBox.getAttribute('data-tx-original-html');
      if (payment) payment.innerHTML = payment.getAttribute('data-tx-original-html');
      if (savings) {
        savings.innerHTML = savings.getAttribute('data-tx-original-html');
        savings.hidden = false;
      }
      return;
    }

    var variant = sizePriceForCard(card, selected);
    if (!variant || !variant.price) return;
    var money = priceBox.querySelector('.money');
    if (money) money.textContent = formatMoney(variant.price);
    if (payment) payment.textContent = formatMoney(Math.round(variant.price / 48)) + '/mo';
    if (savings) {
      var savingsAmount = variant.comparePrice > variant.price ? variant.comparePrice - variant.price : 0;
      savings.hidden = savingsAmount <= 0;
      if (savingsAmount > 0) savings.textContent = 'Save ' + formatMoney(savingsAmount);
    }
  }

  function readSelections() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.slice(0, MAX_COMPARE) : [];
    } catch (error) {
      return [];
    }
  }

  function writeSelections(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (error) {}
  }

  function cardData(card) {
    var titleLink = card.querySelector('h3.t4s-product-title a, .t4s-product-title a, h3 a');
    var image = card.querySelector('img');
    var price = card.querySelector('.t4s-product-price, .tx-mattress-card__price, [class*="price"]');
    var bestFor = card.querySelector('.tx-mattress-card__best, .tx-mattress-card__best-for, [class*="best-for"]');
    var specs = Array.prototype.map.call(card.querySelectorAll('.tx-mattress-card-conversion li, [aria-label="Mattress specifications"] li'), function (item) {
      return item.textContent.trim();
    }).filter(Boolean).slice(0, 4);
    var href = titleLink ? titleLink.href : '';
    var productId = '';
    try { productId = JSON.parse(card.getAttribute('data-product-options') || '{}').id || ''; } catch (error) {}
    return {
      id: productId || card.getAttribute('data-product-id') || href,
      title: titleLink ? titleLink.textContent.trim() : 'Mattress',
      href: href,
      image: image ? (image.currentSrc || image.src) : '',
      price: price ? price.textContent.replace(/\s+/g, ' ').trim() : '',
      bestFor: bestFor ? bestFor.textContent.replace(/^Best for:?\s*/i, '').trim() : '',
      specs: specs
    };
  }

  function injectStyles() {
    if (document.getElementById('tx-compare-styles')) return;
    var style = document.createElement('style');
    style.id = 'tx-compare-styles';
    style.textContent = [
      '.t4s-pr-compare{display:none!important}',
      '.tx-compare-toggle{display:block;width:100%;margin:12px 0 0;padding:10px 14px;border:1px solid #153a67;border-radius:999px;background:#fff;color:#0b2c57;font:700 13px/1.2 inherit;letter-spacing:.04em;text-align:center;cursor:pointer}',
      '.tx-compare-toggle:hover,.tx-compare-toggle[aria-pressed="true"]{background:#edf4fb}',
      '.tx-compare-toggle[aria-pressed="true"]:before{content:"✓ ";color:#bd0015}',
      '.tx-compare-tray{position:fixed;z-index:9996;left:50%;bottom:18px;transform:translateX(-50%);width:min(920px,calc(100% - 28px));display:none;align-items:center;gap:14px;padding:13px 16px;background:#0b2c57;color:#fff;border-radius:16px;box-shadow:0 16px 45px rgba(0,0,0,.28)}',
      '.tx-compare-tray.is-visible{display:flex}',
      '.tx-compare-tray__summary{min-width:150px}.tx-compare-tray__summary strong{display:block;font-size:15px}.tx-compare-tray__summary span{font-size:12px;opacity:.82}',
      '.tx-compare-tray__items{display:flex;gap:8px;flex:1;min-width:0}',
      '.tx-compare-tray__item{display:flex;align-items:center;gap:8px;min-width:0;max-width:185px;padding:6px 8px;background:rgba(255,255,255,.1);border-radius:10px}',
      '.tx-compare-tray__item img{width:38px;height:38px;object-fit:cover;border-radius:6px}.tx-compare-tray__item span{font-size:11px;line-height:1.25;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}',
      '.tx-compare-tray button{border:0;cursor:pointer}.tx-compare-tray__view{padding:11px 17px;border-radius:999px;background:#fff;color:#0b2c57;font-weight:800;white-space:nowrap}.tx-compare-tray__view:disabled{opacity:.5;cursor:not-allowed}.tx-compare-tray__clear{background:transparent;color:#fff;text-decoration:underline;font-size:12px}',
      '.tx-compare-modal{position:fixed;z-index:9998;inset:0;display:none;align-items:center;justify-content:center;padding:22px;background:rgba(5,19,38,.72)}.tx-compare-modal.is-open{display:flex}',
      '.tx-compare-modal__panel{position:relative;width:min(1080px,100%);max-height:90vh;overflow:auto;background:#fff;border-radius:18px;padding:28px;color:#0b2c57}',
      '.tx-compare-modal__close{position:absolute;z-index:3;right:18px;top:16px;display:inline-flex;align-items:center;justify-content:center;min-width:92px;min-height:40px;padding:8px 14px;border:0;border-radius:999px;background:#082a59!important;color:#fff!important;font-size:13px!important;font-weight:850;line-height:1;box-shadow:0 6px 18px rgba(8,42,89,.2);cursor:pointer}.tx-compare-modal__close:hover{background:#af000b!important}.tx-compare-modal h2{margin:0 118px 20px 0;font-size:28px}',
      '.tx-compare-grid{display:grid;gap:14px;grid-template-columns:repeat(var(--tx-compare-count),minmax(0,1fr))}',
      '.tx-compare-card{border:1px solid #d9e2ec;border-radius:14px;overflow:hidden}.tx-compare-card img{width:100%;aspect-ratio:1.55;object-fit:cover}.tx-compare-card__body{padding:16px}.tx-compare-card h3{font-size:18px;margin:0 0 8px}.tx-compare-card__price{font-weight:800;margin-bottom:10px}.tx-compare-card dl{margin:0}.tx-compare-card dt{margin-top:11px;font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:#5c6f83}.tx-compare-card dd{margin:3px 0 0}.tx-compare-card a{display:inline-flex;margin-top:15px;padding:10px 14px;border-radius:999px;background:#174d86;color:#fff;font-weight:800}',
      '.tx-compare-modal__footer{display:flex;justify-content:center;padding-top:22px}.tx-compare-modal__footer button{min-height:44px;padding:10px 22px;border:1px solid #082a59;border-radius:999px;background:#fff;color:#082a59;font-size:13px;font-weight:850;cursor:pointer}.tx-compare-modal__footer button:hover{background:#082a59;color:#fff}',
      '@media(max-width:749px){.tx-compare-tray{bottom:10px;flex-wrap:wrap}.tx-compare-tray__items{order:3;width:100%;overflow:auto}.tx-compare-tray__item{min-width:145px}.tx-compare-tray__clear{margin-left:auto}.tx-compare-grid{grid-template-columns:1fr}.tx-compare-modal{padding:10px}.tx-compare-modal__panel{padding:68px 16px 22px}.tx-compare-modal__close{right:14px;top:14px}.tx-compare-modal h2{margin:0 0 18px;font-size:23px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureCompareUI() {
    if (!document.querySelector('[data-tx-collection-tools]')) return;
    injectStyles();
    if (!document.getElementById('tx-compare-tray')) {
      document.body.insertAdjacentHTML('beforeend', '<aside class="tx-compare-tray" id="tx-compare-tray" aria-live="polite"><div class="tx-compare-tray__summary"><strong>Compare mattresses</strong><span data-tx-compare-count>0 of 3 selected</span></div><div class="tx-compare-tray__items" data-tx-compare-items></div><button class="tx-compare-tray__clear" type="button" data-tx-compare-clear>Clear</button><button class="tx-compare-tray__view" type="button" data-tx-compare-view disabled>Compare now</button></aside><div class="tx-compare-modal" id="tx-compare-modal" aria-hidden="true"><div class="tx-compare-modal__panel" role="dialog" aria-modal="true" aria-labelledby="tx-compare-title"><button class="tx-compare-modal__close" type="button" aria-label="Close comparison" data-tx-compare-close>Close ×</button><h2 id="tx-compare-title">Mattress comparison</h2><div data-tx-compare-grid></div><div class="tx-compare-modal__footer"><button type="button" data-tx-compare-close>Close comparison</button></div></div></div>');
      document.querySelector('[data-tx-compare-clear]').addEventListener('click', function () {
        writeSelections([]);
        closeCompare();
        renderCompareUI();
      });
      document.querySelector('[data-tx-compare-view]').addEventListener('click', openCompare);
      document.querySelector('[data-tx-compare-close]').addEventListener('click', closeCompare);
      document.getElementById('tx-compare-modal').addEventListener('click', function (event) {
        if (event.target === event.currentTarget) closeCompare();
      });
    }
    addCompareButtons();
    renderCompareUI();
  }

  function addCompareButtons() {
    var selected = readSelections();
    document.querySelectorAll('[data-tx-sizes]').forEach(function (card) {
      var data = cardData(card);
      if (!data.href) return;
      var button = card.querySelector('.tx-compare-toggle');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'tx-compare-toggle';
        button.setAttribute('data-tx-compare-id', data.id);
        button.setAttribute('aria-pressed', selected.some(function (item) { return item.id === data.id; }) ? 'true' : 'false');
        button.textContent = 'Compare';
      }
      var target = card.querySelector('.tx-mattress-card, .tx-mattress-card-conversion, .t4s-product-info__inner') || card;
      if (button.parentElement !== target) target.appendChild(button);
    });
  }

  function renderCompareUI() {
    var selected = readSelections();
    var tray = document.getElementById('tx-compare-tray');
    if (!tray) return;
    tray.classList.toggle('is-visible', selected.length > 0);
    tray.querySelector('[data-tx-compare-count]').textContent = selected.length + ' of ' + MAX_COMPARE + ' selected';
    tray.querySelector('[data-tx-compare-view]').disabled = selected.length < 2;
    tray.querySelector('[data-tx-compare-items]').innerHTML = selected.map(function (item) {
      return '<div class="tx-compare-tray__item">' + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '') + '<span>' + escapeHtml(item.title) + '</span></div>';
    }).join('');
    document.querySelectorAll('.tx-compare-toggle').forEach(function (button) {
      var active = selected.some(function (item) { return item.id === button.getAttribute('data-tx-compare-id'); });
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.textContent = active ? 'Added to Compare' : 'Compare';
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char];
    });
  }

  function openCompare() {
    var selected = readSelections();
    if (selected.length < 2) return;
    var modal = document.getElementById('tx-compare-modal');
    var grid = modal.querySelector('[data-tx-compare-grid]');
    grid.style.setProperty('--tx-compare-count', selected.length);
    grid.className = 'tx-compare-grid';
    grid.innerHTML = selected.map(function (item) {
      return '<article class="tx-compare-card">' + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '') + '<div class="tx-compare-card__body"><h3>' + escapeHtml(item.title) + '</h3><div class="tx-compare-card__price">' + escapeHtml(item.price) + '</div><dl>' + (item.bestFor ? '<dt>Best for</dt><dd>' + escapeHtml(item.bestFor) + '</dd>' : '') + (item.specs.length ? '<dt>Key features</dt><dd>' + escapeHtml(item.specs.join(' · ')) + '</dd>' : '') + '</dl><a href="' + escapeHtml(item.href) + '">View mattress</a></div></article>';
    }).join('');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.querySelector('[data-tx-compare-close]').focus();
  }

  function closeCompare() {
    var modal = document.getElementById('tx-compare-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function applySizeFilter() {
    var tools = document.querySelector('[data-tx-collection-tools]');
    if (!tools) return;
    var selected = normalizeSize(new URLSearchParams(location.search).get('tx_size'));
    var isRV = tools.hasAttribute('data-tx-rv-collection');
    if (isRV && selected !== 'short queen' && selected !== 'rv king') selected = 'short queen';
    var rvVariants = {};
    if (isRV) {
      try { rvVariants = JSON.parse(tools.querySelector('[data-tx-rv-variants]').textContent); } catch (error) {}
    }
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-tx-sizes]'));
    var visible = 0;
    cards.forEach(function (card) {
      var sizes = String(card.getAttribute('data-tx-sizes') || '').split('|').map(normalizeSize);
      var match = !selected || sizes.indexOf(selected) !== -1;
      card.hidden = !match;
      updateCardPrice(card, selected);
      if (isRV && match) {
        var productOptions = {};
        try { productOptions = JSON.parse(card.getAttribute('data-product-options') || '{}'); } catch (error) {}
        var variants = (rvVariants[productOptions.handle] || []).filter(function (variant) {
          return normalizeSize(variant.option1) === selected;
        }).sort(function (a, b) { return a.price - b.price; });
        var rvVariant = variants[0];
        if (rvVariant) {
          card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
            try {
              var target = new URL(link.href);
              target.searchParams.set('variant', rvVariant.id);
              link.href = target.toString();
            } catch (error) {}
          });
        }
      }
      if (match) visible += 1;
    });
    document.querySelectorAll('[data-tx-size-link]').forEach(function (link) {
      var active = normalizeSize(link.getAttribute('data-size')) === selected;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    });
    var status = document.querySelector('[data-tx-size-status]');
    if (status) status.textContent = visible + ' matching mattress' + (visible === 1 ? '' : 'es') + ' shown on this page.';
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (!selected || !/page=/.test(link.href) || !link.href.includes('/collections/')) return;
      try { var url = new URL(link.href); url.searchParams.set('tx_size', new URLSearchParams(location.search).get('tx_size')); link.href = url.toString(); } catch (error) {}
    });
  }

  function initialize() {
    if (!document.querySelector('[data-tx-collection-tools]')) return;
    applySizeFilter();
    ensureCompareUI();
    [250, 900, 2200].forEach(function (delay) {
      setTimeout(function () {
        applySizeFilter();
        addCompareButtons();
        renderCompareUI();
      }, delay);
    });
    if (!observer) {
      observer = new MutationObserver(function () {
        clearTimeout(observerTimer);
        observerTimer = setTimeout(function () { applySizeFilter(); addCompareButtons(); renderCompareUI(); }, 120);
      });
      var grid = document.querySelector('#tx-mattress-products, [data-contentlm-replace], .t4s-products');
      if (grid) observer.observe(grid, {childList:true, subtree:true});
    }
  }

  document.addEventListener('click', function (event) {
    var builtIn = event.target.closest && event.target.closest('a.t4s-pr-compare');
    if (builtIn && builtIn.closest('[data-tx-sizes]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    var toggle = event.target.closest && event.target.closest('.tx-compare-toggle');
    if (toggle) {
      var card = toggle.closest('[data-tx-sizes]');
      var data = cardData(card);
      var selected = readSelections();
      var index = selected.findIndex(function (item) { return item.id === data.id; });
      if (index > -1) selected.splice(index, 1);
      else if (selected.length < MAX_COMPARE) selected.push(data);
      else {
        var count = document.querySelector('[data-tx-compare-count]');
        if (count) count.textContent = 'Choose up to ' + MAX_COMPARE + ' mattresses';
        return;
      }
      writeSelections(selected);
      renderCompareUI();
      return;
    }
    if (event.target.closest && event.target.closest('[data-tx-compare-clear]')) {
      writeSelections([]); closeCompare(); renderCompareUI(); return;
    }
    if (event.target.closest && event.target.closest('[data-tx-compare-view]')) { openCompare(); return; }
    if (event.target.closest && (event.target.closest('[data-tx-compare-close]') || event.target.id === 'tx-compare-modal')) { closeCompare(); }
  }, true);

  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeCompare(); });
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState !== 'loading') initialize();
}());
